const AccordionTabContent = ({ children }) => {
  return (
    <div className="spo-m-accordion__content m-accordion__content">
      <div className="u-padding">{children}</div>
    </div>
  );
};

export default AccordionTabContent;
